export default __webpack_public_path__ + "static/media/logo.704cba0a.svg";